import { Link } from 'react-router-dom';
import { AppIcon } from '../components/AppIcon';
import { apps } from '../data/apps';

export function LegalIndexPage({ type }) {
  const title = type === 'privacy' ? 'Privacy by app' : 'Terms by app';
  const intro = type === 'privacy'
    ? '2xHappiness keeps privacy policies separated by app, because each product can use different features, permissions, and services.'
    : '2xHappiness keeps terms separated by app, so each product has rules that match its actual features.';

  return (
    <section className="legal-page">
      <div className="legal-hero">
        <p className="eyebrow">2xHappiness</p>
        <h1>{title}</h1>
        <p>{intro}</p>
      </div>
      <div className="app-grid">
        {apps.filter((app) => app.isListed !== false).map((app) => (
          <article className={`app-card ${app.accent}`} key={app.slug}>
            <AppIcon app={app} />
            <h3>{app.name}</h3>
            <p>{app.tagline}</p>
            <div className="app-card-actions">
              <LegalLink app={app} type={type} />
              <Link className="secondary-action" to={`/apps/${app.slug}`}>App page</Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function LegalLink({ app, type }) {
  const label = type === 'privacy' ? 'Read Privacy' : 'Read Terms';

  if (app.legalMode === 'external') {
    return (
      <a className="primary-action" href={type === 'privacy' ? app.privacyUrl : app.termsUrl}>{label}</a>
    );
  }

  return (
    <Link className="primary-action" to={`/apps/${app.slug}/${type}`}>{label}</Link>
  );
}
